import { Injectable, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { fromEvent } from 'rxjs';
import { map, takeWhile } from 'rxjs/operators';
import { WarningSessionTimeoutComponent } from 'src/app/shared/components/warning-session-timeout/warning-session-timeout.component';
import { Routes } from '../constants/routes';
import { ApiService } from './api.service';
const route = {
    refreshToken: `/auth/refresh-token`,
    refreshAnonymousToken: `/anonymous/refresh-cookie`
};
@Injectable({
    providedIn: 'root'
})
export class TimeoutSessionService implements OnInit {
    subscribe: boolean = true;
    check: number = 0;
    setTime: any = null;
    isActive: boolean = false;
    date: Date;
    public href = '';
    constructor(
        private dialog: MatDialog,
        private apiService: ApiService,
        private router: Router
    ) { }

    ngOnInit(): void {
    }

    refreshToken() {
        return this.apiService.post(route.refreshToken).pipe(map(res => {
            return res;
        }));
    }

    refreshAnonymousToken() {
        return this.apiService.post(route.refreshAnonymousToken).pipe(map(res => {
            return res;
        }));
    }

    stop() {
        this.subscribe = false
        clearInterval(this.setTime);
    }

    start(date: Date) {
        this.href = this.router.url;
        this.date = date
        clearInterval(this.setTime);
        this.check = 0;
        this.isActive = false
        this.checkTimeout();
    }

    startCheck() {
        const timePerCheck = 120000;
        const deltaTimePerCheck = 15000;
        this.setTime = setInterval(() => {
            var currentDate = Number(new Date());
            // lần check cuối cung sẽ đc gọi ở 9'45s
            if (this.check === 5 && (currentDate - this.date.getTime()) > this.check * timePerCheck - deltaTimePerCheck) {
                if (this.isActive) {
                    this.checkTimeout();
                } else
                    this.stop();
            }
            if ((currentDate - this.date.getTime()) > this.check * timePerCheck) {
                if (this.check <= 4) {
                    this.checkTimeout();
                }
            }
        }, 1000)

    }

    checkTimeout() {
        if (!(sessionStorage.getItem('token')
            || (sessionStorage.getItem('tenantId') && localStorage.getItem('SignDataValidate')))
            || this.href.includes(Routes.ENTERPRISE_LOGIN)) {
            this.stop();
        }
        this.check += 1
        this.handleEvent();
        if (this.check === 1) {
            this.startCheck()
        }
        if (this.isActive) {
            if (this.href.includes('sign-anonymous')) {
                this.refreshAnonymousToken().subscribe(res => {
                });
            } else {

                const token = sessionStorage.getItem('token');
                if (token) {
                    this.refreshToken().subscribe(res => {
                    });
                }
            }
        }
    }

    detailHandleEvent() {
        if (this.isActive == false) {
            this.isActive = true
        } else {
            this.subscribe = false
        }
    }

    handleEvent() {
        this.subscribe = true
        fromEvent(document, 'click').pipe(takeWhile(() => this.subscribe)).subscribe(() => {
            this.detailHandleEvent()
        });
        fromEvent(document, 'keyup').pipe(takeWhile(() => this.subscribe)).subscribe(() => {
            this.detailHandleEvent()
        });
        fromEvent(document, 'wheel').pipe(takeWhile(() => this.subscribe)).subscribe(() => {
            this.detailHandleEvent()
        });
        fromEvent(document, 'mousemove').pipe(takeWhile(() => this.subscribe)).subscribe(() => {
            this.detailHandleEvent()
        });
    }
}
